import React, { useEffect, useState } from "react";

export default function ShippingMessage(props) {
  // GET DAY OF THE WEEK
  const d = new Date();
  let day = d.getDay();

  // PROPS COMING FROM ProductScreen,ShippingMessageCreateForm, ProductLandings
  const { product } = props;

  const [hasMessageToDisplay, setHasMessageToDisplay] = useState();
  const [weekEndMessage, setWeekEndMessage] = useState();
  const [midWeekMessage, setMidWeekMessage] = useState();
  const [holidayMessage, setHolidayMessage] = useState();
  const [preOrderMessage, setPreOrderMessage] = useState();

  useEffect(() => {
    if (product?.estimatedShippingTimeMessage?.messageToDisplay) {
      const messageToDisplay =
        product.estimatedShippingTimeMessage.messageToDisplay;

      const weekEndMessage =
        product.estimatedShippingTimeMessage?.defaultMessage?.weekEndMessage;

      const midWeekMessage =
        product.estimatedShippingTimeMessage?.defaultMessage?.midWeekMessage;

      const holidayMessage =
        product.estimatedShippingTimeMessage?.holidayMessage?.message;

      const preOrderMessage =
        product.estimatedShippingTimeMessage?.preOrderMessage?.message;

      setHasMessageToDisplay(messageToDisplay);
      setWeekEndMessage(weekEndMessage);
      setMidWeekMessage(midWeekMessage);
      setHolidayMessage(holidayMessage);
      setPreOrderMessage(preOrderMessage);
    }
  }, [product]);

  return hasMessageToDisplay === "midWeekMessage" ? (
    day === 0 || day === 6 ? (
      weekEndMessage.includes("Yurtiçi") ? (
        <div className="row-left-align-center-nowrap">
          <img
            className="smallest-image"
            src="../../../../images/yurtici-logo.png"
            alt="Yurtiçi Kargo logosu"
          />
          <p className="fs1 padq">{weekEndMessage}</p>
        </div>
      ) : (
        <p className="fs1 padq">{weekEndMessage}</p>
      )
    ) : midWeekMessage.includes("Yurtiçi") ? (
      <div className="row-left-align-center-nowrap">
        <img
          className="smallest-image"
          src="../../../../images/yurtici-logo.png"
          alt="Yurtiçi Kargo logosu"
        />
        <p className="fs1 padq">{midWeekMessage}</p>
      </div>
    ) : (
      <p className="fs1 padq">{midWeekMessage}</p>
    )
  ) : hasMessageToDisplay === "holidayMessage" ? (
    holidayMessage.includes("Yurtiçi") ? (
      <div className="row-left-align-center-nowrap">
        <img
          className="smallest-image"
          src="../../../../images/yurtici-logo.png"
          alt="Yurtiçi Kargo logosu"
        />
        <p className="fs1 padq">{holidayMessage}</p>
      </div>
    ) : (
      hasMessageToDisplay === "holidayMessage" && (
        <p className="fs1 padq">{holidayMessage}</p>
      )
    )
  ) : (
    hasMessageToDisplay === "preOrderMessage" &&
    (preOrderMessage.includes("Yurtiçi") ? (
      <div className="row-left-align-center-nowrap">
        <img
          className="smallest-image"
          src="../../../../images/yurtici-logo.png"
          alt="Yurtiçi Kargo logosu"
        />
        <p className="fs1 padq">{preOrderMessage}</p>
      </div>
    ) : (
      hasMessageToDisplay === "preOrderMessage" && (
        <p className="fs1 padq">{preOrderMessage}</p>
      )
    ))
  );
}
